const tim = {};

export default {
  tim,
};
